
export const Billers = {
    LOADING_BILLERS_LIST: "LOADING_BILLERS_LIST",
    GET_BILLERS_LIST: "GET_BILLERS_LIST",
  };

